import React, {useState, useEffect, useCallback} from 'react';
import {observer} from 'mobx-react';
import SearchStore from 'js/store/SearchStore';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';

import classes from './SearchPagination.module.pcss';
import SearchPaginationService from './SearchPaginationService';

export interface Props {
    pages: number,
    pageChange: Function
}

const SearchPagination = ({pages, pageChange}: Props) => {
    const step:number = 1;
    const {searchPage, isAISearch} = SearchStore;
    const [paginationMapping, setPaginationMapping] = useState([]);

    const sendMixPanelPageClickEvent = useCallback(async (item: number) => {
        await MixPanelWrapper.TrackEvent(
            'Nav Page',
            {
                category: 'Search Nav',
                value: `${item}`,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
    }, [isAISearch]);

    const sendMixPanelArrowClickEvent = useCallback(async (eventName: 'Nav Prev' | 'Nav Next', eventValue: number) => {
        await MixPanelWrapper.TrackEvent(
            eventName,
            {
                category: 'Search Nav',
                value: `${eventValue}`,
                searchType: isAISearch ? 'AI' : 'Regular'
            });
    }, [isAISearch]);

    const previousButtonHandler = useCallback(async () => {
        const prev = searchPage - step;
        pageChange(prev);
        await sendMixPanelArrowClickEvent('Nav Prev',  prev);
    }, [pageChange, searchPage, sendMixPanelArrowClickEvent]);

    const nextButtonHandler = useCallback(async () => {
        const next = searchPage + step;
        pageChange(next);
        await sendMixPanelArrowClickEvent('Nav Next',  next);
    }, [pageChange, searchPage, sendMixPanelArrowClickEvent]);

    const setActiveClass = useCallback((currentPage: number) => {
        if (searchPage === currentPage) {
            return classes.SearchPaginationItemActive;
        }
    }, [searchPage]);


    useEffect(() => {
        setPaginationMapping(SearchPaginationService.getPagination(searchPage, pages));
    }, [setPaginationMapping, searchPage, pages]);

    if (pages < 2) {
        return null;
    }
    return (
        <ul data-search-pagination={true} className={classes.SearchPagination} id="SearchPagination">
            {searchPage > 1 ? <li data-pagination-prev={true} className={`${classes.SearchPaginationItem} ${classes.SearchPaginationItemArrow} ${classes.Previous}`} onClick={previousButtonHandler}></li> : null}
            {paginationMapping?.map((item, index) =>
                typeof item === 'number' ?
                <li
                    data-pagination-page={true}
                    className={`${classes.SearchPaginationItem} ${setActiveClass(item) || ''}`}
                    key={index}
                    onClick={async () => {
                        await pageChange(item);
                        await sendMixPanelPageClickEvent(item);
                    }}>
                    {item}
                </li> :
                <li
                    key={index}
                    className={`${classes.SearchPaginationItem} ${classes.SearchPaginationDots}`}><span>...</span>
                </li>
            )}
            {searchPage !== pages ? <li data-pagination-next={true}
                                        className={`${classes.SearchPaginationItem} ${classes.SearchPaginationItemArrow} ${classes.Next}`}
                                        onClick={nextButtonHandler}></li> : null}
        </ul>
    );
};

export default observer(SearchPagination);
